// extracted by mini-css-extract-plugin
module.exports = {"container":"PaymentMethodsEmpty_container__vH-qd","icon":"PaymentMethodsEmpty_icon__AhN5k","description":"PaymentMethodsEmpty_description__296WR"};